import moment from "moment";

import apiUrl from "api-url";
import buildFetchDuck from "vendor/signal-utils/build-fetch-duck";
import chainReducers from "vendor/signal-utils/chain-reducers";
import { PackageStatusOption } from "pages/partview/utils/filter.utils";

const STORE_MOUNT_POINT = "partViewDashboardPG";

//Ducks
const exceptionCountsFetchDuckPG = buildFetchDuck(
  STORE_MOUNT_POINT,
  "exceptionCounts",
  {},
);
const activeAndExceptionCountsFetchDuckPG = buildFetchDuck(
  STORE_MOUNT_POINT,
  "activeExceptionAndPackageStatusCounts",
  {},
);

const etaPackagesCountsFetchDuckPG = buildFetchDuck(
  STORE_MOUNT_POINT,
  "etaPackagesCounts",
  {},
);

// Action Creators
function fetchExceptionOrPackageStatusCountsPG(
  fvOrgId = null,
  isDealerOrg = false,
  includeAPU,
) {
  let version;

  if (isDealerOrg || fvOrgId) {
    version = "PARTSELLER_COUNT";
  } else {
    version = "COUNT";
  }

  // Default lifecycleStates for shipper and dealer for organizations that doesn't required Available For Pickup(APU).
  const lifecycleOptionsParamList = [
    PackageStatusOption.CREATED_OR_PACKAGED.value,
    PackageStatusOption.IN_ROUTE.value,
    PackageStatusOption.DELAYED.value,
    PackageStatusOption.DELIVERED.value,
  ];

  // Include Available For Pickup(APU) to lifecycleState for organizations that requires.
  if (includeAPU) {
    lifecycleOptionsParamList.push(
      PackageStatusOption.AVAILABLE_FOR_PICKUP.value,
    );
  }

  return (dispatch) => {
    const url = apiUrl("/partview/app/search");
    const config = {
      headers: {
        Accept: `application/json;version=${version}`,
      },
      params: {
        fvOrgId,
        status: "active",
        lifecycleState: lifecycleOptionsParamList.join(","), // To format lifecycleState qsp value into "Created/Packaged,In Route,Delayed,Available for Pickup"
      },
    };
    return dispatch(exceptionCountsFetchDuckPG.fetch(url, config));
  };
}

// only for dealer dashabord
function fetchActiveAndExceptionCountsPG(fvOrgId = null, includeAPU) {
  // Default lifecycleStates for shipper and dealer for organizations that doesn't required Available For Pickup(APU).
  const lifecycleOptionsParamList = [
    PackageStatusOption.CREATED_OR_PACKAGED.value,
    PackageStatusOption.IN_ROUTE.value,
    PackageStatusOption.DELAYED.value,
    PackageStatusOption.DELIVERED.value,
  ];

  // Include Available For Pickup(APU) to lifecycleState for organizations that requires.
  if (includeAPU) {
    lifecycleOptionsParamList.push(
      PackageStatusOption.AVAILABLE_FOR_PICKUP.value,
    );
  }

  return (dispatch) => {
    const url = apiUrl("/partview/app/search");
    const config = {
      headers: {
        Accept: `application/json;version=COUNT`,
      },
      params: {
        fvOrgId,
        status: "active",
        lifecycleState: lifecycleOptionsParamList.join(","), // To format lifecycleState qsp value into "Created/Packaged,In Route,Delayed,Available for Pickup"
      },
    };
    return dispatch(activeAndExceptionCountsFetchDuckPG.fetch(url, config));
  };
}

//only for dealer dashboard
function fetchEtaPackagesCountsPG(fvOrgId) {
  return (dispatch) => {
    const url = apiUrl("/partview/app/eta-count/packages");
    //added config with header and params, added x-time-zone in the header
    const config = {
      headers: { "x-time-zone": moment.tz.guess() },
      params: { fvOrgId: fvOrgId },
    };
    return dispatch(etaPackagesCountsFetchDuckPG.fetch(url, config));
  };
}

const PartViewDashboardStatePG = {
  mountPoint: STORE_MOUNT_POINT,
  actionCreators: {
    fetchExceptionOrPackageStatusCountsPG,
    fetchEtaPackagesCountsPG,
    fetchActiveAndExceptionCountsPG,
  },
  selectors: {
    getExceptionCountsRequestData: exceptionCountsFetchDuckPG.selectors.getData,
    getActiveAndExceptionCountsRequestDataPG:
      activeAndExceptionCountsFetchDuckPG.selectors.getData,
    getEtaPackagesCountsRequestDataPG:
      etaPackagesCountsFetchDuckPG.selectors.getData,
  },
  reducer: chainReducers([
    exceptionCountsFetchDuckPG.reducer,
    activeAndExceptionCountsFetchDuckPG.reducer,
    etaPackagesCountsFetchDuckPG.reducer,
  ]),
};

export default PartViewDashboardStatePG;
